var chunkPrefetchChunkToChildrenMap = {"9892":[3771],"5236":[3771,7604],"8860":[9886],"8742":[1862],"4998":[2478],"4606":[9028],"2501":[3771]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkPrefetchChunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};
